import AntdMessage from 'antd/lib/message';
import 'antd/lib/message/style';

const message = {
    ...AntdMessage,
}
export default message;



// WEBPACK FOOTER //
// ./src/components/message/index.tsx